// export const API_URL = "http://localhost:8000/api";
export const API_URL = "https://api.sooru.ai/api";
// export const API_URL = "https://api.sooru.ai/api";